import { AUTO_REPLY_STATUS } from '@/consts/enum';
import { StandardResponse } from '@/types/response';

import AppApi from './app-api';

export interface AutoReplyShop {
  user_id: string;
  platform: string;
  user_name: string;
  shop_name: string;
  shop_id: string;
  is_auto_reply: AUTO_REPLY_STATUS;
}

export interface AutoReplyUpdateResponse {
  affected: number;
  is_auto_reply: AUTO_REPLY_STATUS;
}

export interface AutoReplyPreference {
  user_id: string;
  is_auto_reply: boolean;
}

export interface AutoReplyUpdateBody {
  is_auto_reply: AUTO_REPLY_STATUS;
}

export class AutoReplyApi {
  constructor(private readonly api: AppApi) {}

  // GET / - 댓글 자동등록 관리 대상 조회
  async getAutoReplyShops(params?: {
    user_id?: string;
    shop_id?: string;
  }): Promise<StandardResponse<AutoReplyShop[]>> {
    const res = await this.api.INSTANCE.get('/auto-reply', { params });
    return res.data;
  }

  // PATCH /user/:user_id - 사용자 기준 일괄 자동등록 상태 업데이트
  async updateUserAutoReply(
    userId: string,
    body: AutoReplyUpdateBody,
  ): Promise<StandardResponse<AutoReplyUpdateResponse>> {
    const res = await this.api.INSTANCE.patch(`/auto-reply/user/${userId}`, body);
    return res.data;
  }

  async getUserAutoReplyPreference(userId: string): Promise<StandardResponse<AutoReplyPreference>> {
    const res = await this.api.INSTANCE.get(`/auto-reply/user/${userId}`);
    return res.data;
  }
}
